"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNotificationSettings = exports.rootSaveSearchSagas = void 0;
var UpdateSaveSearchSaga_1 = require("@/pages/savesearch/sagas/UpdateSaveSearchSaga");
var RootMemberPageSaga_1 = require("@/pages/common/sagas/RootMemberPageSaga");
var getNotificationSettings = function (state) {
    return state.savesearch.currentNotificationSettings;
};
exports.getNotificationSettings = getNotificationSettings;
var rootSaveSearchSagas = {
    rootMemberPageSagas: RootMemberPageSaga_1.rootMemberPageSagas,
    updateSaveSearchSagas: UpdateSaveSearchSaga_1.updateSaveSearchSagas,
};
exports.rootSaveSearchSagas = rootSaveSearchSagas;
